
    import axios from 'axios'
    import store from '../store/index.js'

    export default {
        async add_user_badges(params)  {
            return await axios.post('user_badges/create.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async get_user_badges()  {
            // return await axios.get('user_badges/read.php')
            // .then(r =>{
            //     return r
            // })
            // .catch(e =>{
            //     console.log(e);
            // })
            store.commit('get_user_badges')
        },
        async delete_user_badges(user_badge_id)  {
            return await axios.post('user_badges/delete.php' , {
                user_badge_id : user_badge_id
            })
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async getOne(user_badge_id)  {
            return await axios.post('user_badges/readOne.php' , {
                user_badge_id : user_badge_id
            })
            .then(r =>{
                return r
                
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async update_user_badges(params)  {
            return await axios.post('user_badges/update.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async report_user_badges(params)  {
            return await axios.post('user_badges/report.php',params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
    }
